import { SettingConst } from '@faire/web-api--source/types';

/**
 * Setting to control international buying nudges
 */
export const INTERNATIONAL_BUYING_NUDGES_V2 =
  'INTERNATIONAL_BUYING_NUDGES_V2' as SettingConst<
    'INTERNATIONAL_BUYING_NUDGES_V2',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
